// extracted by mini-css-extract-plugin
export default {"link":"MainPage_link__F1OAi","row":"MainPage_row__dl89J","col":"MainPage_col__WQ965"};